import { TitleText } from '@calendly/ui/components/typography'

export const PanelContentTitle = (props) => <TitleText as="p" size="x-small" {...props} />
